import React from 'react';
import { ExclamationTriangleIcon, ArrowPathIcon } from '@heroicons/react/24/outline';

// Pantalla de error compartida por los visores 3D. `onBack`/`backLabel`
// difieren entre páginas (la vista pública vuelve al inicio, la autenticada
// vuelve atrás en el historial).
const ErrorScreen = ({ error, onBack, backLabel = 'Volver atrás' }) => (
    <div className="absolute inset-0 bg-base-300/90 flex items-center justify-center z-50">
        <div className="text-center max-w-md mx-auto px-6">
            <ExclamationTriangleIcon className="w-16 h-16 text-error mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-base-content mb-2">Error al cargar el modelo</h3>
            <p className="text-sm text-base-content/70 mb-6">{error}</p>
            <div className="space-y-3">
                <button
                    onClick={() => window.location.reload()}
                    className="btn btn-primary w-full gap-2"
                >
                    <ArrowPathIcon className="w-4 h-4" />
                    <span>Reintentar</span>
                </button>
                <button
                    onClick={onBack}
                    className="btn btn-neutral w-full"
                >
                    {backLabel}
                </button>
            </div>
        </div>
    </div>
);

export default ErrorScreen;
